<template>
  <CreateEditRoleForm
    :role-id="roleId"
    @submit="onSubmit"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  roleId: string
}>()
const router = useRouter()

const onSubmit = () => router.push({ name: "roleIndex" })
</script>
